import { render, staticRenderFns } from "./BuffManagementDialog.vue?vue&type=template&id=24f39ea7&"
import script from "./BuffManagementDialog.vue?vue&type=script&lang=js&"
export * from "./BuffManagementDialog.vue?vue&type=script&lang=js&"
import style0 from "./BuffManagementDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports